import { getUserContextItem } from "@/persistence/user_context";

import { injectScript } from "@/utils/script";

/**
 * [오너 계정] 고객을 끌어당기는 구글 애널리틱스 4
 */
const OWNER_GA_ID = 'G-PZVJCGLTH8'

const GTAG_SRC = `https://www.googletagmanager.com/gtag/js?id=${OWNER_GA_ID}`

declare global {
  interface Window {
    dataLayer: any
    gtag: any
  }
}

export const initGoogleAnalytics = async () => {
  const debug_mode = await getUserContextItem({ key: 'debug_mode' });
  const guestGa4Id = await getUserContextItem({ key: 'ga4_id' });
  const guestUserId = await getUserContextItem({ key: 'user_id' })

  const hasTempGaId = window.location.href.includes('tempGaId=')

  // 초기화가 중복되는 부분들이 안되도록 설정
  injectScript({
    src: GTAG_SRC,
    onload: () => {
      window.dataLayer = window.dataLayer || [];

      function gtag(){ window.dataLayer.push(arguments);}

      window.gtag = gtag;
      window.gtag('js', new Date());

      /*
       * [오너 계정] 유저 아이디 설정
       */
      if (guestUserId) {
        window.gtag('config', OWNER_GA_ID, { user_id: guestUserId });
      }

      /*
       * [오너 계정] 디버그 모드 설정
       */
      window.gtag('config', OWNER_GA_ID, { debug_mode });

      /*
       * [유저 계정] 유저 아이디 설정
       */
      if (guestGa4Id && guestUserId) {
        window.gtag('config', guestGa4Id, { user_id: guestUserId, debug_mode });
      }

      /*
       * [유저 계정] 디버그 모드 설정
       */
      if (guestGa4Id && !guestUserId) {
        window.gtag('config', guestGa4Id, { debug_mode });
      }

      if (hasTempGaId) {
        const tempGaId = new URLSearchParams(window.location.search).get('tempGaId')
        window.gtag('config', tempGaId, { debug_mode: true });
      }
    }
  })
}

export const setGaUserProperties = (properties: any) => {
  if (!window.gtag) { return }

  console.log('setUserProperties', properties)

  window.gtag('set', 'user_properties', properties);
}

export const sendEvent = (eventName: string, eventInfos: any) => {
  if (!window.gtag) { return }

  console.log('sendEvent', sendEvent)

  window.gtag('event', eventName, eventInfos)
}